import React, { useState } from "react";
import { HiOutlineChevronDown } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineMenu } from "react-icons/md";
import { Cookies } from "react-cookie";
import Button from "../Inputs/Button";

const Menu = ({ setMenuOpen }) => {
  const pathName = useLocation().pathname;
  const navigate = useNavigate();

  const handleClickLink = (param) => {
    navigate(param);
    setMenuOpen(false);
  };
  const links = [
    { id: 1, textLink: "Home", link: "/" },
    { id: 3, textLink: "Products", link: "/products" },

    { id: 4, textLink: "About", link: "/about-us" },
  ];

  return (
    <div className="">
      <div className="flex flex-col items-center menu-height lg:hidden ">
        <div className="pt-20">
          <ul className="">
            {links.map(({ id, textLink, link, hasOthers }) => (
              <li
                className={`text-[#192851] font-normal flex gap-1 justify-center items-center text-base py-6 text-center ${
                  pathName == link && "active2"
                }`}
                key={id}
                onClick={() => handleClickLink(link)}
              >
                <p href={link}>{textLink}</p>
                {hasOthers && (
                  <HiOutlineChevronDown
                    className="group-hover:text-gray-800 mt-[1px]"
                    size={20}
                    color="#475467"
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Header = () => {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav
        id="header"
        className="sticky   w-full z-30 top-0 bg-[#FFF] border-b-[2px]  border-b-[rgba(111,108,108,0.11)]"
      >
        <div className="w-full px-4 sm:pl-10 sm:pr-8 mt-2 mx-auto flex h-[78px] items-center justify-between  ">
          <div className="flex gap-[20%] flex-1 items-center">
            <div className="sm:pl-4  py-[16px]  flex cursor-pointer  gap-4 items-center">
              <a href="/">
                <img
                  src={require("../../Assets/Logo/logo-transparent.png")}
                  className="w-[35px] object-contain h-[28px]"
                />
              </a>
              <a href="/" className="hidden sm:block">
                <h4 className="font-[500]  text-[18px] text-[#000000]">
                  Greengate pharma
                </h4>
              </a>
            </div>
            <div className=" lg:flex lg:w-auto hidden mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20">
              <ul className="list-reset lg:flex justify-end flex-1 items-center">
                <li
                  onClick={() => {
                    navigate("/");
                  }}
                  className={`mr-3 group flex h-full min-w-[120px] justify-center items-center gap-2 px-4 hover:bg-[rgba(14,138,40,0.90)] transition-all duration-500 ease-in-out  py-2 cursor-pointer ${
                    pathname === "/" ? "bg-[rgba(14,138,40,0.90)]" : ""
                  }`}
                >
                  <p
                    className={`group-hover:text-[#FFF] min-w-[70px] text-center inline-block  no-underline  text-[14px] font-[500]  transition duration-300 ease-in-out ${
                      pathname === "/" ? "text-[#FFF]" : "text-[#000000]"
                    }`}
                  >
                    Home
                  </p>
                </li>
                <li
                  onClick={() => {
                    navigate("/products");
                  }}
                  className={`mr-3 group flex h-full min-w-[120px] justify-center items-center gap-2 px-4 hover:bg-[rgba(14,138,40,0.90)] transition-all duration-500 ease-in-out  py-2 cursor-pointer ${
                    pathname === "/products" ? "bg-[rgba(14,138,40,0.90)]" : ""
                  }`}
                >
                  <p
                    className={`group-hover:text-[#FFF] min-w-[70px] text-center inline-block no-underline  text-[14px] font-[500]  transition duration-300 ease-in-out ${
                      pathname === "/products"
                        ? "text-[#FFF]"
                        : "text-[#000000]"
                    }`}
                  >
                    Products
                  </p>
                </li>

                <li
                  onClick={() => {
                    navigate("/about-us");
                  }}
                  className={`mr-3 group flex h-full min-w-[120px] justify-center items-center gap-2 px-4 hover:bg-[rgba(14,138,40,0.90)] transition-all duration-500 ease-in-out  py-3 cursor-pointer ${
                    pathname === "/about-us" ? "bg-[rgba(14,138,40,0.90)]" : ""
                  }`}
                >
                  <p
                    className={`group-hover:text-[#FFF] min-w-[70px] text-center inline-block  no-underline  text-[14px] font-[500]  transition duration-300 ease-in-out ${
                      pathname === "/about-us"
                        ? "text-[#FFF]"
                        : "text-[#000000]"
                    }`}
                  >
                    {" "}
                    About us
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <Button
            type={"link"}
            link={"mailto:info.greengatepharma@gmail.com"}
            title={"Contact us"}
          />
          <div className="block py-[16px] ml-3 lg:hidden pr-4">
            <button
              id="nav-toggle"
              className="flex items-center p-1 text-[#000] focus:outline-none focus:shadow-outlinet"
            >
              {!menuOpen ? (
                <MdOutlineMenu
                  size={"30px"}
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="cursor-pointer"
                />
              ) : (
                <span onClick={() => setMenuOpen(!menuOpen)}>
                  <AiOutlineClose size={"30px"} color="#000" />
                </span>
              )}
            </button>
          </div>
        </div>
      </nav>
      {menuOpen && (
        <div
          className={`fixed mt-[0px] w-full h-full z-50 bg-white ${
            menuOpen ? "menu-wrapper " : " menu-hidden"
          }`}
        >
          <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        </div>
      )}
    </>
  );
};

export default Header;
